module.exports = __webpack_public_path__ + "static/media/Avatar2.0c779b75.png";